module.exports = __webpack_public_path__ + "011-medal-1.7001349d.svg";